<template>
  <v-container
    fluid
    tile
    class="pa-0"
    :style="'background-color: ' + this.webTheme.colors.content.hexa + ';'"
  >
    <v-row no-gutters justify="center">
      <v-col xs="12" :sm="component.settings.cols">
        <v-sheet tile :color="this.webTheme.colors.content.hexa" :style="block">
          <v-row no-gutters justify="center">
            <v-col>
              <view-text :settings="component.title"></view-text>
            </v-col>
          </v-row>

          <v-row v-for="(category, id) in categories" :key="id" no-gutters>
            <v-col>
              <v-row no-gutters>
                <view-text
                  :settings="component.category"
                  :value="category.title"
                ></view-text>
              </v-row>

              <v-row
                v-if="component.card.group.slider === 'slide'"
                :justify="component.card.group.justify"
                no-gutters
              >
                <v-col :lg="component.card.group.cols">
                  <v-card
                    tile
                    elevation="0"
                    :class="grid.inner"
                    background-color="transparent"
                  >
                    <v-slide-group
                      :dark="component.card.group.dark"
                      show-arrows="always"
                    >
                      <v-slide-item
                        v-for="(card, i) in category.articleList"
                        :key="i"
                      >
                        <v-card
                          :class="classes"
                          :style="styles + ';' + gradient"
                          :height="cardHeight"
                          :width="component.card.width"
                          :elevation="component.card.elevation"
                          @click="openArticlePopUp(card)"
                        >
                          <v-img
                            v-if="component.image.show === true"
                            :height="component.image.height + 'px'"
                            :lazy-src="card.image.mediumUrl"
                            :src="card.image.mediumUrl"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                            <v-row
                              v-if="card.videoUrl"
                              justify="center"
                              align="center"
                              class="fill-height"
                              no-gutters
                            >
                              <v-btn fab large dark color="#21212185"
                                ><v-icon :color="primary" size="50"
                                  >play_arrow</v-icon
                                ></v-btn
                              >
                            </v-row>
                          </v-img>
                          <v-card-text :style="cardText">
                            <v-row no-gutters v-if="card.title">
                              <v-col>
                                <view-text
                                  :settings="component.heading"
                                  :value="card.title"
                                />
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <view-text
                                  :settings="component.date"
                                  :value="date(card.updated)"
                                />
                              </v-col>
                              <v-col>
                                <view-text
                                  :settings="component.author"
                                  :value="getAuthorName(card.updatedBy)"
                                />
                              </v-col>
                            </v-row>
                            <v-row
                              no-gutters
                              v-if="
                                card.body && component.settings.previewRows > 0
                              "
                            >
                              <v-col>
                                <view-text
                                  :settings="component.body"
                                  :value="card.body"
                                  :lines="component.settings.previewRows"
                                />
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-slide-item>
                    </v-slide-group>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else no-gutters :justify="component.card.group.justify">
                <v-col :lg="component.card.group.cols">
                  <v-card tile elevation="0" :class="grid.inner">
                    <v-row
                      class="mx-2 mx-lg-0"
                      :justify="component.card.group.justify"
                    >
                      <v-card
                        v-for="(card, i) in category.articleList"
                        :key="i"
                        :class="classes"
                        :height="component.card.height"
                        :width="component.card.width"
                        :style="styles + ';' + gradient"
                        :elevation="component.card.elevation"
                        @click="openArticlePopUp(card)"
                      >
                        <v-img
                          v-if="component.image.show === true"
                          :height="component.image.height + 'px'"
                          :lazy-src="card.image.mediumUrl"
                          :src="card.image.mediumUrl"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                          <v-row
                            v-if="card.videoUrl"
                            justify="center"
                            align="center"
                            class="fill-height"
                            no-gutters
                          >
                            <v-btn fab large dark color="#21212185"
                              ><v-icon :color="primary" size="50"
                                >play_arrow</v-icon
                              ></v-btn
                            >
                          </v-row>
                        </v-img>
                        <div>
                          <v-row no-gutters v-if="card.title">
                            <v-col>
                              <view-text
                                :settings="component.heading"
                                :value="card.title"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters>
                            <v-col>
                              <view-text
                                :settings="component.date"
                                :value="date(card.updated)"
                              />
                            </v-col>
                            <v-col>
                              <view-text
                                :settings="component.author"
                                :value="getAuthorName(card.updatedBy)"
                              />
                            </v-col>
                          </v-row>
                          <v-row no-gutters v-if="card.body">
                            <v-col>
                              <view-text
                                :settings="component.body"
                                :value="card.body"
                                :lines="4"
                              />
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <article-dialog
      v-if="showArticle"
      :is-visible="showArticle"
      :on-close="closeArticlePopUp"
      :article="activeArticle"
      :component="component"
    ></article-dialog>

    <article-dialog-video
      v-if="showArticleVideo"
      :open="showArticleVideo"
      @onClose="closeArticleVideoPopUp"
      :article="activeArticle"
    ></article-dialog-video>
  </v-container>
</template>

<script>
import ViewText from "../Text.vue";
import ArticleDialog from "./ArticleDialog.vue";
import ArticleDialogVideo from "./ArticleDialogVideo.vue";

import moment from "moment";

export default {
  components: {
    ViewText,
    ArticleDialog,
    ArticleDialogVideo
  },
  props: ["component"],
  created() {
    // Make sure admins data is loaded
    if (this.$store.getters.admins.length === 0) {
      this.$store.dispatch("loadAdmins");
    }
  },
  data: function() {
    return {
      showArticle: false,
      showArticleVideo: false,
      activeArticle: {},
      articleCategories: []
    };
  },
  computed: {
    cardHeight() {
      if (this.component.card.autoHeight === true) {
        return "auto";
      }
      return this.component.card.height;
    },
    primary() {
      return this.webTheme.colors.primary.hex;
    },
    classes() {
      var classes = this.component.card.rounded;
      return classes;
    },
    grid() {
      return this.$store.getters.grid;
    },
    block() {
      var padding = this.component.block.padding;
      return (
        this.grid.block +
        "px ;" +
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    cardText() {
      var padding = this.component.card.textAreaPadding;
      return (
        "padding-left: " +
        padding.left +
        "px ;" +
        "padding-right: " +
        padding.right +
        "px ;" +
        "padding-top: " +
        padding.top +
        "px ;" +
        "padding-bottom: " +
        padding.bottom +
        "px ;"
      );
    },
    gradient() {
      if (this.component.card.color.type === "gradient") {
        var color = this.component.card.color;
        var gradient =
          "background: linear-gradient(" +
          color.direction +
          ", rgba(" +
          color.gradientFrom.rgba.r +
          ", " +
          color.gradientFrom.rgba.g +
          ", " +
          color.gradientFrom.rgba.b +
          ", " +
          color.gradientFrom.rgba.a +
          ") " +
          ", rgba(" +
          color.gradientTo.rgba.r +
          ", " +
          color.gradientTo.rgba.g +
          ", " +
          color.gradientTo.rgba.b +
          ", " +
          color.gradientTo.rgba.a +
          ")" +
          color.gradientHeight +
          "%)";
        return gradient;
        // return 'background: linear-gradient(to top, rgba(0, 0, 255, 100), rgba(255, 0, 0, 100) 50%)'
      } else {
        return "background: " + this.component.card.color.solidColor.hexa + ";";
      }
    },
    styles() {
      var styles =
        "margin-bottom: " +
        this.component.card.margin.bottom +
        "px ;" +
        "margin-top: " +
        this.component.card.margin.top +
        "px ;" +
        "margin-left: " +
        this.component.card.margin.left +
        "px ;" +
        "margin-right: " +
        this.component.card.margin.right +
        "px ;" +
        "padding-bottom: " +
        this.component.card.padding.bottom +
        "px ;" +
        "padding-top: " +
        this.component.card.padding.top +
        "px ;" +
        "padding-left: " +
        this.component.card.padding.left +
        "px ;" +
        "padding-right: " +
        this.component.card.padding.right +
        "px ;" +
        "border: " +
        this.component.card.borderSize +
        "px solid " +
        this.component.card.borderColor.hexa +
        "; ";
      return styles;
    },
    webTheme() {
      return this.$store.getters.currentProgram.webTheme;
    },
    blogAuthorMap() {
      const admins = this.$store.getters.admins || [];
      if (admins.length === 0) {
        return {};
      }
      return admins.reduce((result, item) => {
        return {
          ...result,
          [item.userId]: item.name
        };
      }, {});
    },
    primaryMenus() {
      return this.$store.getters.primaryMenus;
    },
    promotionList() {
      return this.$store.getters.promotionList || {};
    },
    screenDetail() {
      return (
        this.primaryMenus.find(
          menuDetail =>
            menuDetail.content === this.component.settings.selectedBlog
        ) || {}
      );
    },
    categories() {
      // First try the regular way
      const regularCategories = this.articleCategories.filter(
        el => el.idToCompare === this.component.settings.selectedArticleCategory
      );

      // If we have regular categories, use them
      if (regularCategories && regularCategories.length > 0) {
        return regularCategories;
      }

      // If no regular categories, but we have promotionList data, use that
      if (Object.keys(this.promotionList).length > 0) {
        // Get the selected blog ID from component settings
        const selectedBlogId = this.component.settings.selectedBlog;

        // If we have a specific blog selected and that blog exists in the promotionList
        if (selectedBlogId && this.promotionList[selectedBlogId]) {
          // Get the selected category if any
          const selectedCategory = this.component.settings
            .selectedArticleCategory;

          // Find the category title from primaryMenus
          let categoryTitle = "";

          // First look for the category in the screenDetail
          if (this.screenDetail && this.screenDetail.blogs) {
            const categoryObj = Object.values(this.screenDetail.blogs).find(
              blog => blog.idToCompare === selectedCategory
            );
            if (categoryObj && categoryObj.title) {
              categoryTitle = categoryObj.title;
            }
          }

          // Fallback to looking through all primaryMenus
          if (!categoryTitle) {
            for (const menu of this.primaryMenus) {
              if (menu.blogs) {
                const categoryObj = Object.values(menu.blogs).find(
                  blog => blog.idToCompare === selectedCategory
                );
                if (categoryObj && categoryObj.title) {
                  categoryTitle = categoryObj.title;
                  break;
                }
              }
            }
          }

          // If still no title found, use a fallback or the first article's blogTitle
          if (!categoryTitle) {
            const articleList = this.promotionList[selectedBlogId];
            if (
              articleList &&
              articleList.length > 0 &&
              articleList[0].blogTitle
            ) {
              categoryTitle = articleList[0].blogTitle;
            } else {
              categoryTitle = selectedCategory || "Articles";
            }
          }

          return [
            {
              id: selectedBlogId,
              title: categoryTitle,
              idToCompare: selectedCategory || "all", // Respect category filter
              articleList: this.promotionList[selectedBlogId]
            }
          ];
        }
      }

      // Fallback to empty array
      return [];
    }
  },
  watch: {
    screenDetail: {
      immediate: true,
      handler(value) {
        if (value && value.blogs && Object.values(value.blogs).length > 0) {
          this.articleCategories = Object.values(value.blogs);
        }
      }
    }
  },
  mounted() {
    if (this.screenDetail && this.screenDetail.blogs) {
      this.articleCategories = Object.values(this.screenDetail.blogs);
    }

    if (
      (!this.screenDetail.blogs ||
        Object.values(this.screenDetail.blogs).length === 0) &&
      Object.keys(this.promotionList).length > 0
    ) {
      // Promotions list data is available but no blogs in screenDetail
    }
  },
  methods: {
    date(date) {
      return moment(date).format("ddd MMMM Do YYYY");
    },
    getAuthorName(adminId) {
      return this.blogAuthorMap[adminId] || this.$t("AUTHOR") || "Author";
    },
    openArticlePopUp(article) {
      this.activeArticle = article;
      if (article.videoOnlyPost === true) {
        this.openArticleVideoPopUp();
      } else {
        this.showArticle = true;
      }
    },
    closeArticlePopUp() {
      this.showArticle = false;
      this.activeArticle = null;
    },
    openArticleVideoPopUp() {
      this.showArticleVideo = true;
    },
    closeArticleVideoPopUp() {
      this.showArticleVideo = false;
      this.activeArticle = null;
    }
  }
};
</script>

<style scoped></style>
